<template>
  <div class="foot-btn-container">
    <span class="dialog-footer">
      <el-button v-if="showClosedBtn" @click="onClosed">{{
        closeName ? closeName : $t("msg.universal.cancel")
      }}</el-button>
      <el-button v-if="showConfirmBtn" type="primary" @click="onConfirm">{{
        confirmName ? confirmName : $t("msg.universal.confirm")
      }}</el-button>
    </span>
  </div>
</template>

<script setup>
const props = defineProps({
  showClosedBtn: {
    // 是否显示取消按钮
    required: false,
    type: Boolean,
    default: true,
  },
  closeName: {
    required: false,
    type: String,
    default: null,
  },
  showConfirmBtn: {
    // 是否显示确定按钮
    required: false,
    type: Boolean,
    default: true,
  },
  confirmName: {
    required: false,
    type: String,
    default: null,
  },
});
const emits = defineEmits(["onClosed", "onConfirm"]);
const onClosed = () => {
  emits("onClosed");
};

const onConfirm = () => {
  emits("onConfirm");
};
</script>

<style scoped></style>
